module.exports = __webpack_public_path__ + "static/media/projection.b1e5ba92.png";